export default {
    meta: {
        title: '加盟商编辑',
        url: '/fishtogether/franchiseelist',
        urlName: '鱼你加盟商管理',
    }
};
